import { getAllRegions } from '@/api/system'
import { getMemberLevels } from '@/api/member'
import { getSupplierList } from '@/api/supplier'
import { getCategories, getBrandList } from '@/api/goods'
import { getProfitSetting, getExpressDeliveries } from '@/api/system'

export default {
  namespaced: true,
  state: {
    brandList: localStorage.getItem('brandList') || [],
    regionList: localStorage.getItem('regionList') || [],
    categoryList: localStorage.getItem('categoryList') || [],
    supplierList: localStorage.getItem('supplierList') || [],
    memberLevels: localStorage.getItem('memberLevels') || [],
    deliveryList: localStorage.getItem('deliveryList') || [],
    profitSetting: {},
    zones: ['激活专区一', '激活专区二', '激活专区三'],
    mallTypes: ['积分商城', '优品商城', '福利商城', '特权礼包'],
    units: ['件', '箱', '个', '盒', '双', '套', '升', '千克'],
    priceTypes: ['纯现金，现金+积分，现金+券', '纯积分', '现金+积分', '现金+券', '积分+券', '现金+积分，现金+券']
  },
  mutations: {
    SET_REGION: (state, list) => {
      state.regionList = list
      localStorage.setItem('regionList', list)
    },
    SET_BRAND: (state, list) => {
      state.brandList = list
      localStorage.setItem('brandList', list)
    },
    SET_CATEGORY: (state, list) => {
      state.categoryList = list
      localStorage.setItem('categoryList', list)
    },
    SET_SUPPLIER: (state, list) => {
      state.supplierList = list
      localStorage.setItem('supplierList', list)
    },
    SET_PROFIT: (state, setting) => {
      state.profitSetting = setting
    },
    SET_MEMBER_LEVEL: (state, list) => {
      state.memberLevels = list
      localStorage.setItem('memberLevels', list)
    },
    SET_DELIVERY: (state, list) => {
      state.deliveryList = list
      localStorage.setItem('deliveryList', list)
    }
  },
  actions: {
    init: async({ commit }) => {
      try {
        const brands = await getBrandList()
        const regions = await getAllRegions()
        const setting = await getProfitSetting()
        const deliveries = await getExpressDeliveries()
        const levels = await getMemberLevels({ status: 1 })
        const categories = await getCategories(undefined, 1)
        const suppliers = await getSupplierList({ status: 1 })

        commit('SET_BRAND', brands)
        commit('SET_REGION', regions)
        commit('SET_PROFIT', setting)
        commit('SET_SUPPLIER', suppliers)
        commit('SET_CATEGORY', categories)
        commit('SET_MEMBER_LEVEL', levels)
        commit('SET_DELIVERY', deliveries)
      } catch (error) { }
    }
  }
}
